import { getTeamAnalysis } from "src/api/Admin"

export interface TeamAnalysisData{
    team_name: string,
    leader_name: string,
    participation_count: number,
    attendee_count: number,
    interested_count: number,
    apply_count: number,
    commissioned_count: number,
    not_interested_count: number
}

export const LoadTeamAnalysis = async (start_date: string|null, end_date: string|null)=>{
    const response = await getTeamAnalysis(start_date, end_date)
    return response.data as TeamAnalysisData[]
}